<template>
  <v-popover
    offset="16"
    :open="open"
    trigger="click"
    :auto-hide="false"
    :handle-resize="true"
    :container="target"
    style="height:100%;"
    placement="auto"
  >
    <template slot="popover">
      <div class="event-tooltip">
        <div class="popover-arrow">
          <v-btn
            v-if="!(userRole === 'student' && event.cancelled)"
            color="primary"
            @click="redirect({ path: '/classes/' + event.id })"
            >{{ t("scheduler.event.see") }}</v-btn
          >
        </div>
        <div class="popover-header">
          <h3 class="popover-title">{{ event.title + displayOccurrence() }}</h3>
          <p class="overline">{{ event.abstract }}</p>
        </div>
        <div class="popover-content">
          <v-card class="mx-auto" max-width="300" tile>
            <v-list dense>
              <v-subheader>{{
                t("user.roles.teacher.title_plural")
              }}</v-subheader>
              <v-list-item-group color="primary">
                <v-list-item
                  v-for="teacher in teachers"
                  :key="teacher.id"
                  disabled
                  inactive
                >
                  <v-list-item-content>
                    <v-list-item-title
                      v-text="teacher.firstname + ' ' + teacher.lastname"
                    ></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
              <v-subheader>{{
                t("user.roles.student.title_plural")
              }}</v-subheader>
              <v-list-item-group color="primary">
                <v-list-item
                  v-for="student in students"
                  :key="student.id"
                  disabled
                  inactive
                >
                  <v-list-item-content>
                    <v-list-item-title
                      v-text="student.firstname + ' ' + student.lastname"
                    ></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </div>
      </div>
    </template>
  </v-popover>
</template>

<script>
import { i18n } from "@/services/vue-i18n";
import { eventBus } from "@/main";

export default {
  props: {
    target: {
      type: HTMLElement,
      required: true
    },
    event: {
      type: Object,
      required: true
    },
    userRole: {
      type: String,
      default: "student"
    },
    participations: {
      type: Array,
      default: null
    },
    toggles: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      open: false
    };
  },
  computed: {
    teachers: function() {
      var teachers = [];
      this.participations.forEach(participant => {
        if (participant.role !== "student") {
          teachers.push(participant);
        }
      });
      return teachers;
    },
    students: function() {
      var students = [];
      this.participations.forEach(participant => {
        if (participant.role === "student") {
          students.push(participant);
        }
      });
      return students;
    }
  },
  watch: {
    toggles: {
      handler: function(val) {
        this.open = val[this.event.id];
      },
      deep: true
    }
  },
  methods: {
    displayOccurrence() {
      if (!this.event.occurrence || !this.event.lastOccurrence) {
        return "";
      }
      return (
        " (" + this.event.occurrence + " / " + this.event.lastOccurrence + ")"
      );
    },
    /**
     * Defined to help since the template is out of the app's context.
     */
    t(str) {
      return i18n.t(str);
    },
    redirect(route) {
      eventBus.$emit("redirect", route);
    }
  }
};
</script>

<style scope lang="scss">
.tooltip {
  &.popover {
    z-index: 1000;
    $color: #f9f9f9;
    .popover-inner {
      background: $color;
      color: #000;
      padding: 16px;
      border-radius: 10px;
      box-shadow: 0 5px 30px rgba(black, 0.1);
    }
    .popover-arrow {
      border-color: $color;
      padding-bottom: 16px;
    }
    .event-tooltip {
      overflow: hidden;
    }
    .popover-content {
      overflow-y: scroll;
      max-height: 20vh;
      .theme--light.v-list-item--disabled {
        color: rgba(0, 0, 0, 0.87) !important;
      }
    }
  }
}

.popover-content::-webkit-scrollbar-track {
  box-shadow: 0px 0px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.popover-content::-webkit-scrollbar {
  width: 6px;
  background-color: #f5f5f5;
}

.popover-content::-webkit-scrollbar-thumb {
  background-color: #bbb;
}
</style>
